module.exports = __webpack_public_path__ + "static/media/logo-lak-thueringen_2x.8b89c402.png";